import { render, staticRenderFns } from "./SidebarEditPersonalProfile.vue?vue&type=template&id=8b3a93a8&scoped=true"
import script from "./SidebarEditPersonalProfile.vue?vue&type=script&lang=js"
export * from "./SidebarEditPersonalProfile.vue?vue&type=script&lang=js"
import style0 from "./SidebarEditPersonalProfile.vue?vue&type=style&index=0&id=8b3a93a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3a93a8",
  null
  
)

export default component.exports